import { AppLayout } from '@/components/AppLayout'
import { ProtectedRoute } from '@/components/ProtectedRoute'
import { LoginPage } from '@/pages/LoginPage'
import { RouteResourceFallback } from '@/pages/RouteResourceFallback'
import { BloggerPage } from '@/pages/ai-team/BloggerPage'
import { ChatPage } from '@/pages/ai-team/ChatPage'
import { ConnectionsPage } from '@/pages/ai-team/ConnectionsPage'
import { ModelsPage } from '@/pages/ai-team/ModelsPage'
import { InboxPage } from '@/pages/ai-team/InboxPage'
import { MemoryPage } from '@/pages/ai-team/MemoryPage'
import { CalendarPage } from '@/pages/ai-team/workspace/CalendarPage'
import { JobsPage } from '@/pages/ai-team/workspace/JobsPage'
import { Overview } from '@/pages/ai-team/workspace/Overview'
import { TeamPage } from '@/pages/ai-team/workspace/TeamPage'
import { ActivityPage, SchedulesPage } from '@/pages/ai-team/workspace/TeamPages'
import { SettingsLayout, Workspace } from '@/pages/ai-team/workspace/Workspace'
import { WorkflowCanvasPage } from '@/pages/ai-team/workflows/WorkflowCanvasPage'
import { WorkflowsPage } from '@/pages/ai-team/workflows/WorkflowsPage'
import { BusinessesPage } from '@/pages/apps/businesses/BusinessesPage'
import { FeedControlPage } from '@/pages/apps/feed/FeedControlPage'
import { PostsPage } from '@/pages/apps/posts/PostsPage'
import { BotArmyPage } from '@/pages/controls/BotArmyPage'
import { ScrapersPage } from '@/pages/controls/MiscControlPages'
import { StaffAgentsPage } from '@/pages/controls/StaffAgentsPage'
import { WebScraperPage } from '@/pages/controls/web-scraper/WebScraperPage'
import { DashboardLayout } from '@/pages/dashboard/DashboardLayout'
import { DashboardOverview } from '@/pages/dashboard/DashboardOverview'
import {
  DashboardAI,
  DashboardAnalytics,
  DashboardFinance,
  DashboardScrapers,
  DashboardSystem
} from '@/pages/dashboard/DashboardSubpages'
import { SuperPowersPage } from '@/pages/super-powers/SuperPowersPage'
import { Navigate, Route, Routes } from 'react-router-dom'

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/apps/feed" replace />} />
        <Route path="apps/feed" element={<FeedControlPage />} />
        <Route path="apps/feed/posts" element={<PostsPage />} />
        <Route path="apps/businesses" element={<BusinessesPage />} />
        <Route path="apps/creators" element={<RouteResourceFallback />} />
        <Route path="apps/people" element={<RouteResourceFallback />} />
        <Route path="apps/events" element={<RouteResourceFallback />} />
        <Route path="apps/pricing" element={<RouteResourceFallback />} />
        <Route path="super-powers" element={<SuperPowersPage />} />
        {/* One AI team workspace: hubs and team tools render inside it; chat and the canvas stay full screen. */}
        <Route element={<Workspace />}>
          <Route path="apps/ai-team" element={<Overview />} />
          <Route path="apps/ai-team/team/:hubId" element={<TeamPage />} />
          <Route path="apps/ai-team/calendar" element={<CalendarPage />} />
          <Route path="apps/ai-team/inbox" element={<InboxPage />} />
          <Route path="apps/ai-team/workflows" element={<WorkflowsPage />} />
          <Route path="apps/ai-team/blogger" element={<BloggerPage />} />
          <Route path="apps/ai-team/settings" element={<Navigate to="/apps/ai-team/jobs" replace />} />
          <Route element={<SettingsLayout />}>
            <Route path="apps/ai-team/jobs" element={<JobsPage />} />
            <Route path="apps/ai-team/knows" element={<MemoryPage />} />
            <Route path="apps/ai-team/connections" element={<ConnectionsPage />} />
            <Route path="apps/ai-team/models" element={<ModelsPage />} />
            <Route path="apps/ai-team/routines" element={<SchedulesPage />} />
            <Route path="apps/ai-team/activity" element={<ActivityPage />} />
          </Route>
        </Route>
        <Route path="apps/ai-team/chat" element={<ChatPage />} />
        <Route path="apps/ai-team/chat/:roomId" element={<ChatPage />} />
        <Route path="apps/ai-team/needs-you" element={<Navigate to="/apps/ai-team/inbox" replace />} />
        <Route path="apps/ai-team/workflows/:workflowId" element={<WorkflowCanvasPage />} />
        <Route path="apps/ai-team/*" element={<RouteResourceFallback />} />
        <Route path="dashboard" element={<DashboardLayout />}>
          <Route index element={<DashboardOverview />} />
          <Route path="analytics" element={<DashboardAnalytics />} />
          <Route path="ai" element={<DashboardAI />} />
          <Route path="scrapers" element={<DashboardScrapers />} />
          <Route path="finance" element={<DashboardFinance />} />
          <Route path="system" element={<DashboardSystem />} />
        </Route>
        <Route path="controls/bots" element={<BotArmyPage />} />
        <Route path="controls/staff-agents" element={<StaffAgentsPage />} />
        <Route path="controls/scrapers" element={<ScrapersPage />} />
        <Route path="controls/web-scraper" element={<WebScraperPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/apps/feed" replace />} />
    </Routes>
  )
}
